module.exports = __webpack_public_path__ + "static/LLW-Mono-aa0712807c17cd845aa64b1a41b11986.svg";